import { gql } from '@apollo/client'

export const getApplicationByPartnerId = gql`
  query getApplicationByPartnerId(
    $applicationInput: Credit_BusinessCredit_ApplicationInput!
  ) {
    credit {
      businessCredit {
        application(input: $applicationInput) {
          partnerApplicationId
          creditProductIdentifier
          countryCode
          campaign {
            id
          }
          weeklyPaymentDay
          evaluation {
            underwriting {
              grade
              offerConstraints {
                maxLoanAmount {
                  value
                  currencyCode
                }
              }
            }
            autoQualificationFailureReason
          }
          refinance {
            selected
          }
          business {
            legalBusinessName
            partnerBusinessId
            financialProfile {
              formattedMonthlyAverageGrossScore {
                amount
              }
              averageMonthlyGrossSales {
                value
                currencyCode
              }
            }
            loanHistory {
              formattedTotalOutstandingPrincipalBalance {
                amount(
                  formatOptions: {
                    style: SYMBOL
                    minimumFractionDigits: 0
                    maximumFractionDigits: 0
                  }
                )
              }
              formattedTotalOutstandingInterestBalance {
                amount(
                  formatOptions: {
                    style: SYMBOL
                    minimumFractionDigits: 0
                    maximumFractionDigits: 0
                  }
                )
              }
              previousLoans {
                id
                outstandingPrincipalBalance {
                  currencyCode
                  value
                }
                principalAmount {
                  currencyCode
                  value
                }
                totalCostOfCredit {
                  currencyCode
                  value
                }
                totalLoanTermInterestRate
                grade
                formattedTerm {
                  formattedTimeDuration
                }
              }
            }
            verifiedBankAccounts
          }
          promotions {
            type
            id
            feeWaiver {
              pricingTier
            }
            expiryDate
          }
          tags
        }
      }
    }
  }
`

export const getOfferConstraintsByPartnerId = gql`
  query getOffersById(
    $offerConstraintsInput: Credit_BusinessCredit_OfferConstraintsInput!
  ) {
    credit {
      businessCredit {
        offerConstraints(input: $offerConstraintsInput) {
          productOfferConstraints {
            maxTerm
            minTerm
            maxAmount {
              value
              currencyCode
            }
            minAmount {
              value
              currencyCode
            }
          }
          customOfferConstraints {
            maxProportionOfRevenue
            maxAmount {
              value
              currencyCode
            }
            term
            weeklyInterestRate
            maxAutoQualifiedAmount {
              value
              currencyCode
            }
            tiers {
              tier
              weeklyInterestRate
            }
          }
        }
      }
    }
  }
`

export const getCalculatorOffersByEvaluationId = gql`
  query getCalculatorOffersByEvaluationId(
    $offerEvaluationInput: Credit_BusinessCredit_OfferEvaluationInput!
  ) {
    credit {
      businessCredit {
        offerEvaluation(input: $offerEvaluationInput) {
          offers {
            id
            formattedAmount {
              amount
            }
            formattedWeeklyInterestRate {
              percentage
            }
            formattedTerm {
              formattedTimeDuration(formatOptions: { style: LONG, unit: DAY })
            }
            status
            isQualified
            requiredApproverRole
          }
        }
      }
    }
  }
`
